import { isNumeric } from '@cutwise/utils';
import { MODEL_CONVERSION_PRICE } from '@/spectrum/constants/conversionPrice';
/** @deprecated Use UserV2Model for most cases, since User is deprecated on backend */
export class UserModel {
    id;
    roles;
    deny;
    b2b;
    lastName;
    firstName;
    username;
    email;
    phone;
    utcTimezone;
    locale;
    flags;
    settings;
}
/** @deprecated Use UserV2 for most cases, since User is deprecated on backend */
export class User extends UserModel {
    constructor(modelData = {}) {
        super();
        Object.assign(this, modelData);
        this.flags = modelData?.flags || {};
        // temp hack to disable drive on staging
        // (current drive code requires api which is not ready yet) and obstruct work with collections
        this.flags['allowDrive'] = false;
        this.settings = modelData?.settings || {};
    }
    get isAnonymous() {
        return !this.id;
    }
    get b2bId() {
        return this.b2b?.id ?? null;
    }
    get b2bTitle() {
        return this.b2b?.title ?? null;
    }
    get currency() {
        return this.b2b?.account?.currency ?? null;
    }
    get balance() {
        const balance = this.b2b?.account?.balance;
        if (!balance) {
            return null;
        }
        return +balance;
    }
    get canAffordModelConversion() {
        const balance = this.balance;
        return isNumeric(balance) && balance >= MODEL_CONVERSION_PRICE;
    }
    get getFullName() {
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName}`;
        }
        if (this.firstName) {
            return this.firstName;
        }
        if (this.lastName) {
            return this.lastName;
        }
        return '';
    }
    get getUserRenderName() {
        const userFullName = this.getFullName;
        if (userFullName) {
            return userFullName;
        }
        if (this.username) {
            return this.username;
        }
        return 'Unknown user';
    }
    isFlagAllowed(flagName) {
        return Boolean(this.flags?.[flagName]);
    }
}
